export class SensitivityCategoryEntity {
  public name!: string;
  public description!: string;
}
